// Who may delete a lead. Mirrors `allow delete` on /leads/{leadId} in
// firestore.rules: a lead that carries a server-only field (won_deal or an
// ads_offline_conversion_* field) needs the rules' isAdmin(); any other lead
// can be deleted by any signed-in user.

export const SERVER_LEAD_FIELDS = [
  'won_deal',
  'ads_offline_conversion_uploaded_at',
  'ads_offline_conversion_id',
];

export const PROTECTED_DELETE_MESSAGE = 'Only an admin can delete a sold or Ads-uploaded lead';

// Key present, any value, as the rules' keys().hasAny() does.
export const hasServerLeadFields = (lead) =>
  !!lead && SERVER_LEAD_FIELDS.some((field) => Object.prototype.hasOwnProperty.call(lead, field));

// Same test as isAdmin() in firestore.rules. Wider than StateManager.isAdmin(),
// which is userType 'admin' only.
export const isRulesAdmin = ({ userType = '', whiteList = [], archived = false } = {}) =>
  archived !== true
  && (['admin', 'manager'].includes(userType)
    || (Array.isArray(whiteList) && whiteList.includes('user-management')));

export const canDeleteLead = (lead, user) =>
  !hasServerLeadFields(lead) || isRulesAdmin(user);

// Deletes a lead doc (compat DocumentReference). A lead that is already gone
// counts as deleted: if the delete fails and a read shows no doc, resolve
// instead of throwing. Resolves 'deleted' or 'gone'; rethrows any other error.
export const deleteLeadDoc = async (ref) => {
  try {
    await ref.delete();
    return 'deleted';
  } catch (error) {
    let gone = error?.code === 'not-found';
    if (!gone) {
      try {
        gone = !(await ref.get()).exists;
      } catch (readError) {
        gone = false;
      }
    }
    if (gone) return 'gone';
    throw error;
  }
};
